import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  submitForgotPassword,
  setUsername,
  setLoginMode,
  submitMagicLink,
} from '../../../Actions/Login.action';
import { translate } from '../../../Services/translation';
import { LoginModes } from '../../../constants';
import Input from '../../Input';

const LoginForgotPassword = () => {
  const { username = '', isLoading, magicLinkModel } = useSelector(
    (state) => state.login
  );
  const [isSuccessful, setIsSuccessful] = useState(false);
  const dispatch = useDispatch();

  const onSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    dispatch(submitForgotPassword(username)).then((success) =>
      setIsSuccessful(success)
    );
  };

  useEffect(() => {
    // Send magic link on first render only, if magic link model is in state
    if (!magicLinkModel?.link) return;
    dispatch(submitMagicLink(magicLinkModel));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!isSuccessful && !magicLinkModel && (
        <>
          <div className="login__forgot-password-text">
            {translate('login.text.forgot-password')}
          </div>
          <form className="login__form" onSubmit={onSubmit}>
            <Input
              label={translate('login.label.username')}
              value={username}
              onChange={(e) => dispatch(setUsername(e.target.value))}
              disabled={isLoading}
              required
              id="username"
            />
            <button
              className="login__submit-button"
              disabled={isLoading}
              type="submit"
            >
              {translate(isLoading ? 'login.loading' : 'login.send')}
            </button>
          </form>
          <div className="login__additional-actions">
            <button
              className="login__back-button"
              disabled={isLoading}
              onClick={() => dispatch(setLoginMode(LoginModes.Login))}
            >
              {translate(isLoading ? 'login.loading' : 'login.back')}
            </button>
          </div>
        </>
      )}
      {isSuccessful && (
        <>
          <p className="success">
            {translate('login.forgot-password.success')}
          </p>
          <div className="login__additional-actions">
            <button
              className="login__back-button"
              disabled={isLoading}
              onClick={() => dispatch(setLoginMode(LoginModes.Login))}
            >
              {translate('general.back')}
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default LoginForgotPassword;
